import { AxiosRequestConfig } from "axios";
import { getInstance } from "../../core/axios-gateway";
import { TRestListData, TRestListParams } from "../../types/rest";
import { TSupplier } from "../../types/supplier";

export * from "./orders";
export * from "./addresses";
export * from "./products";
export * from "./productsV2";
export * from "./productsV3";
export * from "./global-offers";
export * from "./limits";
export * from "./reports";
export * from "./boxes";
export * from "./payments";
export * from "./permissions";
export * from "./roles";
export * from "./settings";

const BASE_PATH = "/api/suppliers";

export const getSuppliers = async (params: TRestListParams) => {
  // Backoffice never lists sub-suppliers (those with a parentSupplierId): always filter to root suppliers.
  return getInstance()
    .get<TRestListData<TSupplier>>(`${BASE_PATH}/list`, {
      params: { ...params, rootOnly: true },
    })
    .then((res) => res.data);
};

export const getSupplierById = async (
  supplierId: string,
  config?: AxiosRequestConfig
) => {
  return getInstance()
    .get<TSupplier>(`${BASE_PATH}/${supplierId}`, config)
    .then((res) => res.data);
};

export const createSupplier = async (data: TSupplier) => {
  const { id: supplierId } = data;
  return getInstance()
    .post<TSupplier>(`${BASE_PATH}/${supplierId}`, data)
    .then((res) => res.data);
};

export const createSupplierWithoutId = async (data: TSupplier) => {
  return getInstance()
    .post<TSupplier>(BASE_PATH, data)
    .then((res) => res.data);
};

export const updateSupplier = async (
  supplierId: string,
  data: Partial<TSupplier>
) => {
  const payload = sanitizeSupplierPayload(data);
  return getInstance()
    .put<TSupplier>(`${BASE_PATH}/id/${supplierId}`, payload)
    .then((res) => res.data);
};

export type TDeleteSupplierReport = {
  supplier: string;
  sellers: { ok: boolean; error?: string };
  products: { ok: boolean; error?: string };
  esMessages: { ok: boolean; error?: string };
  esProductIndex: { ok: boolean; error?: string };
  esV3: { ok: boolean; error?: string };
  failures: string[];
};

export const deleteSupplier = async (
  supplierId: string,
  confirmationName: string
) => {
  return getInstance()
    .delete<TDeleteSupplierReport>(`${BASE_PATH}/id/${supplierId}`, {
      data: { confirmationName },
    })
    .then((res) => res.data);
};

function sanitizeSupplierPayload(data: Partial<TSupplier>) {
  const payload: any = { ...data };

  if (
    payload.accountGroupId !== undefined &&
    payload.accountGroupId !== null &&
    payload.accountGroupId !== ""
  ) {
    payload.accountGroupId = String(payload.accountGroupId);
  } else if (payload.accountGroupId === "") {
    payload.accountGroupId = null;
  }

  const digitalDocument = payload.digitalDocument as any;
  if (digitalDocument && typeof digitalDocument === "object") {
    payload.digitalDocument =
      typeof digitalDocument.src === "string" ? digitalDocument.src : null;
  }

  return payload;
}
